var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1080px",
    height: "230px",
    viewBox: "0 0 1080 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit---Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Local-/-Background",
    transform: "translate(0.000000, -256.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(0.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 833,
    y: 142.921811,
    width: 2,
    height: 85.1851852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.99941,153.236204 C853.11996,183.032303 834.718271,207.283951 834.718271,207.283951 C834.718271,207.283951 816.121139,183.226563 816.00059,153.430463 C815.88004,123.634363 834.281729,99.382716 834.281729,99.382716 C834.281729,99.382716 852.878861,123.440061 852.99941,153.236204 Z",
    id: "Path",
    fill: "#F2E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.99941,153.236204 C853.11996,183.032303 834.718271,207.283951 834.718271,207.283951 C834.718271,207.283951 816.121139,183.226563 816.00059,153.430463 C815.88004,123.634363 834.281729,99.382716 834.281729,99.382716 C834.281729,99.382716 852.878861,123.440061 852.99941,153.236204 Z",
    id: "Path",
    fill: "#CBA5B9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5D2DC",
    opacity: 0.4,
    cx: 164,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4659348,218.995686 C56.0089022,225.791273 61.2937023,230 61.2937023,230 C61.2937023,230 64.0769824,223.190847 62.5340605,216.39526 C60.9911386,209.599673 55.7063021,205.390947 55.7063021,205.390947 C55.7063021,205.390947 52.923022,212.200088 54.4659348,218.995686 Z",
    id: "Path",
    fill: "#E5D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0420372,217.400055 C60.4602988,222.366072 61,230 61,230 C61,230 54.3762339,229.582413 49.9579628,224.616395 C45.5396917,219.650377 45,212.016461 45,212.016461 C45,212.016461 51.6237661,212.434037 56.0420372,217.400055 Z",
    id: "Path",
    fill: "#F2E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.465935,218.995686 C637.008857,225.791273 642.293702,230 642.293702,230 C642.293702,230 645.076982,223.190847 643.534061,216.39526 C641.991139,209.599673 636.706302,205.390947 636.706302,205.390947 C636.706302,205.390947 633.923022,212.200088 635.465935,218.995686 Z",
    id: "Path",
    fill: "#E5D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.042037,217.400055 C642.460299,222.366072 643,230 643,230 C643,230 636.376234,229.582413 631.957963,224.616395 C627.539692,219.650377 627,212.016461 627,212.016461 C627,212.016461 633.623766,212.434037 638.042037,217.400055 Z",
    id: "Path",
    fill: "#F2E8ED"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "64.929772 167.507646 61 160.005284 97.679772 123.99177 192 123.99177 192 134.495077 157.940076 176.511569 118.639506 185.514403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAE6EA",
    points: "208.425226 145.482955 208.425226 122.098765 196.084919 122.098765 196.084919 129.472637 192.20057 124.433174 160.782146 160.303309 155.545109 166.281304 149 196.173444 160.782146 229.053498 221 229.053498 221 161.797808"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F7F8",
    x: 61,
    y: 160.90535,
    width: 100,
    height: 68.1481481
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 126,
    y: 181.728395,
    width: 21,
    height: 20.8230453
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EAE6EA",
    x: 99,
    y: 181.728395,
    width: 18,
    height: 47.3251029
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "78 189.300412 78 181.728395 70 181.728395 70 189.300412 77.3328499 189.300412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "77.3328499 194.032922 70 194.032922 70 201.604938 78 201.604938 78 194.032922"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 83,
    y: 181.728395,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 83,
    y: 194.032922,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "189 189.300412 189 181.728395 181 181.728395 181 189.300412 188.332931 189.300412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "188.332931 194.979424 181 194.979424 181 202.55144 189 202.55144 189 194.979424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 194,
    y: 181.728395,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 194,
    y: 194.979424,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "443.929772 167.507646 440 160.005284 476.679772 123.99177 571 123.99177 571 134.495077 536.940076 176.511569 497.639506 185.514403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAE6EA",
    points: "587.425226 145.482955 587.425226 122.098765 575.084919 122.098765 575.084919 129.472637 571.20057 124.433174 539.782146 160.303309 534.545109 166.281304 528 196.173444 539.782146 229.053498 600 229.053498 600 161.797808"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F7F8",
    x: 440,
    y: 160.90535,
    width: 100,
    height: 68.1481481
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 505,
    y: 181.728395,
    width: 21,
    height: 20.8230453
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1EEF1",
    x: 478,
    y: 181.728395,
    width: 18,
    height: 47.3251029
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "457 189.300412 457 181.728395 449 181.728395 449 189.300412 456.33285 189.300412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "456.33285 194.032922 449 194.032922 449 201.604938 457 201.604938 457 194.032922"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 462,
    y: 181.728395,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 462,
    y: 194.032922,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "568 189.300412 568 181.728395 560 181.728395 560 189.300412 567.332931 189.300412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "567.332931 194.979424 560 194.979424 560 202.55144 568 202.55144 568 194.979424"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 573,
    y: 181.728395,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 573,
    y: 194.979424,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "266.56532 42.9857641 260 37.0560632 296.767696 0 390 0 390 32.6095935 329.5962 78.5596708"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAE6EA",
    points: "407.460885 20.8585383 407.460885 0.743098909 395.063634 0.743098909 395.063634 5.66976918 390.436599 0 360.18826 37.1840654 348.3527 46.108802 330 197.75167 357.67734 229.053498 422 229.053498 422 38.6713418"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F7F8",
    x: 260,
    y: 37.8600823,
    width: 100,
    height: 191.193416
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EAE6EA",
    x: 299,
    y: 182.674897,
    width: 18,
    height: 46.3786008
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "279 195.925926 279 188.353909 271 188.353909 271 195.925926 278.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "278.333817 200.658436 271 200.658436 271 208.230453 279 208.230453 279 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 284,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 284,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "333 195.925926 333 188.353909 325 188.353909 325 195.925926 332.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "332.333817 200.658436 325 200.658436 325 208.230453 333 208.230453 333 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 338,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 338,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "388 47.3251029 388 39.7530864 380 39.7530864 380 47.3251029 387.333817 47.3251029"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "387.333817 52.0576132 380 52.0576132 380 59.6296296 388 59.6296296 388 52.0576132"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 39.7530864,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 52.0576132,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "388 88.0246914 388 80.4526749 380 80.4526749 380 88.0246914 387.333817 88.0246914"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "387.333817 94.6502058 380 94.6502058 380 102.222222 388 102.222222 388 94.6502058"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 80.4526749,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 94.6502058,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "388 129.670782 388 122.098765 380 122.098765 380 129.670782 387.333817 129.670782"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "387.333817 136.296296 380 136.296296 380 143.868313 388 143.868313 388 136.296296"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 122.098765,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 136.296296,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "388 172.263374 388 164.691358 380 164.691358 380 172.263374 387.333817 172.263374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "387.333817 176.995885 380 176.995885 380 184.567901 388 184.567901 388 176.995885"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 164.691358,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 393,
    y: 176.995885,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 271,
    y: 46.3786008,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 271,
    y: 82.345679,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 271,
    y: 118.312757,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 271,
    y: 154.279835,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "649.56532 42.9857641 643 37.0560632 679.767696 0 773 0 773 32.6095935 712.5962 78.5596708"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAE6EA",
    points: "789.460885 20.8585383 789.460885 0.743098909 777.063634 0.743098909 777.063634 5.66976918 772.436599 0 742.18826 37.1840654 730.3527 46.108802 712 197.75167 739.67734 229.053498 804 229.053498 804 38.6713418"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F7F8",
    x: 643,
    y: 37.8600823,
    width: 100,
    height: 191.193416
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1EEF1",
    x: 682,
    y: 182.674897,
    width: 18,
    height: 46.3786008
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "662 195.925926 662 188.353909 654 188.353909 654 195.925926 661.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "661.333817 200.658436 654 200.658436 654 208.230453 662 208.230453 662 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 667,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 667,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "716 195.925926 716 188.353909 708 188.353909 708 195.925926 715.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "715.333817 200.658436 708 200.658436 708 208.230453 716 208.230453 716 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 721,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 721,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "771 47.3251029 771 39.7530864 763 39.7530864 763 47.3251029 770.333817 47.3251029"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "770.333817 52.0576132 763 52.0576132 763 59.6296296 771 59.6296296 771 52.0576132"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 39.7530864,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 52.0576132,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "771 88.0246914 771 80.4526749 763 80.4526749 763 88.0246914 770.333817 88.0246914"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "770.333817 94.6502058 763 94.6502058 763 102.222222 771 102.222222 771 94.6502058"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 80.4526749,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 94.6502058,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "771 129.670782 771 122.098765 763 122.098765 763 129.670782 770.333817 129.670782"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "770.333817 136.296296 763 136.296296 763 143.868313 771 143.868313 771 136.296296"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 122.098765,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 136.296296,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "771 172.263374 771 164.691358 763 164.691358 763 172.263374 770.333817 172.263374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "770.333817 176.995885 763 176.995885 763 184.567901 771 184.567901 771 176.995885"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 164.691358,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 776,
    y: 176.995885,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 654,
    y: 46.3786008,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 654,
    y: 82.345679,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 654,
    y: 118.312757,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 654,
    y: 154.279835,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "859.56532 42.9857641 853 37.0560632 889.767696 0 983 0 983 32.6095935 922.5962 78.5596708"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAE6EA",
    points: "999.460885 20.8585383 999.460885 0.743098909 987.063634 0.743098909 987.063634 5.66976918 982.436599 0 952.18826 37.1840654 940.3527 46.108802 922 197.75167 949.67734 229.053498 1014 229.053498 1014 38.6713418"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F7F8",
    x: 853,
    y: 37.8600823,
    width: 100,
    height: 191.193416
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1EEF1",
    x: 892,
    y: 182.674897,
    width: 18,
    height: 46.3786008
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "872 195.925926 872 188.353909 864 188.353909 864 195.925926 871.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "871.333817 200.658436 864 200.658436 864 208.230453 872 208.230453 872 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 877,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 877,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "926 195.925926 926 188.353909 918 188.353909 918 195.925926 925.333817 195.925926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "925.333817 200.658436 918 200.658436 918 208.230453 926 208.230453 926 200.658436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 931,
    y: 188.353909,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 931,
    y: 200.658436,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "981 47.3251029 981 39.7530864 973 39.7530864 973 47.3251029 980.333817 47.3251029"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "980.333817 52.0576132 973 52.0576132 973 59.6296296 981 59.6296296 981 52.0576132"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 39.7530864,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 52.0576132,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "981 88.0246914 981 80.4526749 973 80.4526749 973 88.0246914 980.333817 88.0246914"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "980.333817 94.6502058 973 94.6502058 973 102.222222 981 102.222222 981 94.6502058"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 80.4526749,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 94.6502058,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "981 129.670782 981 122.098765 973 122.098765 973 129.670782 980.333817 129.670782"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "980.333817 136.296296 973 136.296296 973 143.868313 981 143.868313 981 136.296296"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 122.098765,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 136.296296,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "981 172.263374 981 164.691358 973 164.691358 973 172.263374 980.333817 172.263374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D1D6",
    points: "980.333817 176.995885 973 176.995885 973 184.567901 981 184.567901 981 176.995885"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 164.691358,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 986,
    y: 176.995885,
    width: 8,
    height: 7.57201646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 864,
    y: 46.3786008,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 864,
    y: 82.345679,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 864,
    y: 118.312757,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 864,
    y: 154.279835,
    width: 76,
    height: 17.9835391
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 0,
    y: 228.106996,
    width: 1080,
    height: 1.89300412
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 240,
    y: 142.921811,
    width: 2,
    height: 85.1851852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.99941,153.236204 C259.11996,183.032303 240.718271,207.283951 240.718271,207.283951 C240.718271,207.283951 222.121139,183.226563 222.00059,153.430463 C221.88004,123.634363 240.281729,99.382716 240.281729,99.382716 C240.281729,99.382716 258.878861,123.440061 258.99941,153.236204 Z",
    id: "Path",
    fill: "#E5D2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 430,
    y: 142.921811,
    width: 2,
    height: 85.1851852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.99941,153.236204 C449.11996,183.032303 430.718271,207.283951 430.718271,207.283951 C430.718271,207.283951 412.121139,183.226563 412.00059,153.430463 C411.88004,123.634363 430.281729,99.382716 430.281729,99.382716 C430.281729,99.382716 448.878861,123.440061 448.99941,153.236204 Z",
    id: "Path",
    fill: "#E5D2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D6D1D6",
    x: 809,
    y: 142.921811,
    width: 2,
    height: 85.1851852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.99941,153.236204 C828.11996,183.032303 809.718271,207.283951 809.718271,207.283951 C809.718271,207.283951 791.121139,183.226563 791.00059,153.430463 C790.88004,123.634363 809.281729,99.382716 809.281729,99.382716 C809.281729,99.382716 827.878861,123.440061 827.99941,153.236204 Z",
    id: "Path",
    fill: "#F2E8ED"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.c726f8a064c70d9050ce1083f36bb37a.svg";
export { ForwardRef as ReactComponent };